import { render } from "./NameBlock.vue?vue&type=template&id=2f0abbc1"
import script from "./NameBlock.vue?vue&type=script&lang=js"
export * from "./NameBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/RuleForm/Blocks/NameBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f0abbc1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f0abbc1', __exports__)) {
    api.reload('2f0abbc1', __exports__)
  }
  
  module.hot.accept("./NameBlock.vue?vue&type=template&id=2f0abbc1", () => {
    api.rerender('2f0abbc1', render)
  })

}


export default __exports__